export default __webpack_public_path__ + "static/media/process_1.a59127ee.png";